import moment from "moment";

export async function getStore(
  accuracy,
  peak_accuracy,
  start_time,
  stop_time,
  seconds,
  mintemp,
  maxtemp,
  random_coefficient,
  maxpeaktemp,
  period
) {
  let accuracy_data = re(accuracy);
  let peak_accuracy_data = re(peak_accuracy);
  let times_data = make_times(start_time, stop_time, seconds);
  let n_data = times_data.length;
  let mint = mintemp[0];
  let minminus = mintemp[1] * -1;
  let minplus = mintemp[2];
  let maxt = maxtemp[0];
  let maxminus = maxtemp[1] * -1;
  let maxplus = maxtemp[2];

  let points_make_waves = make_waves(
    accuracy_data,
    n_data,
    mint,
    minminus,
    minplus,
    maxt,
    maxminus,
    maxplus,
    random_coefficient
  );

  let points_add_peaks = add_peaks(
    points_make_waves,
    peak_accuracy_data,
    mintemp,
    maxpeaktemp,
    random_coefficient,
    period
  );

  let points_sclice_of_time = points_add_peaks
    .map((item) => item)
    .slice(0, times_data.length);

  let ready_dicts = [];

  for (let i = 0; i < times_data.length; i++) {
    ready_dicts.push({
      X: times_data[i],
      Y: points_sclice_of_time[i],
    });
  }

  return ready_dicts;
}

function add_peaks(points, accuracy, mint, maxt, random_coefficient, period) {
  let zeros = getZeros(random_coefficient);
  let mintemp = mint[0];
  let minminus = mint[1] * -1;
  let minplus = mint[2];
  let maxtemp = maxt[0];
  let maxminus = maxt[1] * -1;
  let maxplus = maxt[2];
  let k = 0;

  let response = points.map((item) => item);

  for (let i_to_paste = 0; i_to_paste < points.length; i_to_paste++) {
    k += 1;
    if (k === period) {
      k = 0;
      let left = points[i_to_paste];
      let indexRight = points.length > i_to_paste ? 1 : 0;
      let right = points[i_to_paste + indexRight];
      let accuracy_now = accuracy[getRandom(accuracy.length)];

      let low_initial = make_radians(accuracy_now, mintemp, maxtemp, true);
      let low = low_initial
        .map((item) => item)
        .slice(Math.floor(accuracy_now / 2), accuracy_now - 1);
      let top = make_radians(accuracy_now, mintemp, maxtemp);

      // # делаем нижнюю шапку случайной
      let leftlenLow = Math.floor(low.length / 2);
      let rightlenLow = low.length - leftlenLow;

      let arr_first = [];
      let arr_second = [];

      for (let a = 0; a < rightlenLow; a++) {
        arr_first.push(0);
      }
      for (let a = 0; a < leftlenLow; a++) {
        arr_second.push(0);
      }

      let pluses_low = [
        getSortedChoice(
          minplus,
          minminus,
          random_coefficient * 100,
          zeros,
          rightlenLow
        ),
        getSortedChoice(
          minplus,
          minminus,
          random_coefficient * 100,
          zeros,
          leftlenLow,
          true
        ),
      ];

      if (getRandom(2) === 1) {
        pluses_low = [...pluses_low[0], ...pluses_low[1]];
      } else {
        pluses_low = [...pluses_low[1], ...pluses_low[0]];
      }

      for (let a = 0; a < low.length; a++) {
        low[a] += pluses_low[a];
      }

      let leftlenTop = Math.floor(top.length / 2);
      let rightlenTop = top.length - leftlenTop;

      let arr_top = [
        getSortedChoice(
          maxplus,
          maxminus,
          random_coefficient * 100,
          zeros,
          leftlenTop,
          true
        ),
        getSortedChoice(
          maxplus,
          maxminus,
          random_coefficient * 100,
          zeros,
          rightlenTop
        ),
      ];

      let pluses_top = [];

      if (getRandom(2) === 1) {
        pluses_top = [...arr_top[0], ...arr_top[1]];
      } else {
        pluses_top = [...arr_top[1], ...arr_top[0]];
      }

      for (let a = 0; a < top.length; a++) {
        top[a] += pluses_top[a];
      }

      let waves = [...low, ...top];
      let new_waves = [];

      for (let w of waves) {
        if (!(w <= left || w <= right)) {
          new_waves.push(w);
        }
      }

      response = [
        ...response.slice(0, i_to_paste),
        ...new_waves,
        ...response.slice(i_to_paste),
      ];
    }
  }

  return response;
}

function make_waves(
  accuracy,
  n,
  mint,
  minminus,
  minplus,
  maxt,
  maxminus,
  maxplus,
  random_coefficient
) {
  // # создает волны
  let n_data = n - 1;
  let zeros = getZeros(random_coefficient);
  // # уменьшаем кол-во волн на 1, т.к. начало и конец создаются отдельно
  let randomIndex = Math.floor(Math.random() * accuracy.length);
  let accuracy_top = accuracy[randomIndex];

  let waves_start = make_radians(accuracy_top, mint, maxt, true);
  let waves_end = make_radians(accuracy_top, mint, maxt);

  let waves = [...waves_start.slice(3), ...waves_end.slice(1)];

  // # добавляем первую обрезанную посередине волну

  let accuracy_last = accuracy[getRandom(accuracy.length)];
  let last = make_radians(accuracy_last, mint, maxt, true);
  let last_slice = last.map((item) => item).slice(1, accuracy_last - 3);

  // # находим последнюю
  for (let i = 0; i < n_data; i++) {
    let accuracy_now = accuracy[getRandom(accuracy.length)];

    // # находим остальные, что в середине
    let low_initial = make_radians(accuracy_now, mint, maxt, true);
    let low = low_initial.map((item) => item).slice(1, low_initial.length - 1);
    let top = make_radians(accuracy_now, mint, maxt);

    // # делаем нижнюю шапку случайной
    let leftlenLow = Math.floor(low.length / 2);
    let rightlenLow = low.length - leftlenLow;

    let arr_first = [];
    let arr_second = [];

    for (let a = 0; a < rightlenLow; a++) {
      arr_first.push(0);
    }
    for (let a = 0; a < leftlenLow; a++) {
      arr_second.push(0);
    }

    let pluses_low = [
      getSortedChoice(
        minplus,
        minminus,
        random_coefficient * 100,
        zeros,
        rightlenLow
      ),
      getSortedChoice(
        minplus,
        minminus,
        random_coefficient * 100,
        zeros,
        leftlenLow,
        true
      ),
    ];

    if (getRandom(2) === 1) {
      pluses_low = [...pluses_low[0], ...pluses_low[1]];
    } else {
      pluses_low = [...pluses_low[1], ...pluses_low[0]];
    }

    for (let a = 0; a < low.length; a++) {
      low[a] += pluses_low[a];
    }

    let leftlenTop = Math.floor(top.length / 2);
    let rightlenTop = top.length - leftlenTop;

    let arr_top = [
      getSortedChoice(
        maxplus,
        maxminus,
        random_coefficient * 100,
        zeros,
        leftlenTop,
        true
      ),
      getSortedChoice(
        maxplus,
        maxminus,
        random_coefficient * 100,
        zeros,
        rightlenTop
      ),
    ];

    let pluses_top = [];

    if (getRandom(2) === 1) {
      pluses_top = [...arr_top[0], ...arr_top[1]];
    } else {
      pluses_top = [...arr_top[1], ...arr_top[0]];
    }

    for (let a = 0; a < top.length; a++) {
      top[a] += pluses_top[a];
    }

    waves = [...waves, ...low, ...top];
  }

  waves = [...waves, ...last_slice];

  return waves;
}

function getSortedChoice(plus, minus, random, zeros, counts, reverse) {
  let first = plus * Math.random();
  let second = minus * Math.random();

  let arr = [];
  let report_arr = [];

  for (let i = 0; i < random * 2; i++) {
    if (i === 0 || i % 2 === 0) {
      arr.push(first);
    } else {
      arr.push(second);
    }
  }

  arr = [...arr, ...zeros];

  for (let i = 0; i < counts; i++) {
    let item = arr[getRandom(arr.length)];
    report_arr.push(item);
  }

  if (reverse) {
    return report_arr.reverse();
  } else {
    return report_arr;
  }
}

function getRandom(len) {
  return Math.floor(Math.random() * len);
}

function make_radians(accuracy, mint, maxt, low) {
  if (!low) {
    let float_arr = make_float_range(0, Math.PI, accuracy);

    return float_arr.map((item) => {
      return to_temperature((Math.sin(item) + 1) * 0.5, 0, 1, mint, maxt);
    });
  } else {
    let float_arr = make_float_range(0, Math.PI, accuracy);

    return float_arr.map((item) => {
      return to_temperature((Math.sin(item) * -1 + 1) * 0.5, 0, 1, mint, maxt);
    });
  }
}

function make_float_range(start, stop, n) {
  // # делит промежуток на указанное количество частей
  let n_data = n - 1;
  let plus = (stop - start) / n;
  let lst = [];

  for (let i = 0; i < n_data; i++) {
    lst.push(start + plus * i);
  }
  lst.push(stop);
  return lst;
}

function to_temperature(value, left_min, left_max, right_min, right_max) {
  // # переводит значения из одного диапазона в другой
  let left_span = left_max - left_min;
  let right_span = right_max - right_min;
  let value_scaled = (value - left_min) / left_span.toFixed(1);
  return right_min + value_scaled * right_span;
}

function getZeros(cof) {
  let arr = [];
  let counts = 100 - cof * 100;
  for (let i = 0; i < counts; i++) {
    arr.push(0);
  }

  return arr;
}

function re(items) {
  let new_re = [];
  for (let i of items) {
    if (i % 2 === 1) {
      new_re.push(i);
    }
  }

  return new_re;
}

function make_times(start_time, stop_time, seconds) {
  // # создает временные отметки

  let times = [];
  let duration = moment.duration(moment(stop_time).diff(moment(start_time)));
  let minutes = duration.asMinutes();

  for (let i = 0; i <= minutes; i++) {
    if (i === 0) {
      times.push(start_time);
    } else {
      let time = moment(start_time)
        .add(i, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
      times.push(time);
    }
  }
  return times;
}
